import api from './api';

export type SequenceChannel =
  | 'email'
  | 'linkedinInvite'
  | 'linkedinSend'
  | 'linkedinVisit'
  | 'manual';

export interface SequenceStepDef {
  type: SequenceChannel;
  delay: number; // Wartetage VOR diesem Schritt
  subject?: string;
  body?: string;
}

export interface Sequence {
  id: string;
  name: string;
  description?: string | null;
  steps: SequenceStepDef[];
  lemlistCampaignId?: string | null;
  lemlistSequenceId?: string | null;
  lemlistPushedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PushResult {
  campaignId: string;
  sequenceId: string;
  stepsCreated: number;
  dryRun: boolean;
}

export interface ResyncResult extends PushResult {
  stepsDeleted: number;
}

export const SEQUENCE_CHANNEL_LABELS: Record<SequenceChannel, string> = {
  email: 'E-Mail',
  linkedinInvite: 'LinkedIn-Einladung',
  linkedinSend: 'LinkedIn-Nachricht',
  linkedinVisit: 'LinkedIn-Profilbesuch',
  manual: 'Manuelle Aufgabe',
};

class SequenceService {
  async list(): Promise<Sequence[]> {
    const res = await api.get('/sequences');
    return res.data;
  }

  async get(id: string): Promise<Sequence> {
    const res = await api.get(`/sequences/${id}`);
    return res.data;
  }

  async create(data: { name: string; description?: string; steps?: SequenceStepDef[] }): Promise<Sequence> {
    const res = await api.post('/sequences', data);
    return res.data;
  }

  async update(
    id: string,
    data: { name?: string; description?: string; steps?: SequenceStepDef[] }
  ): Promise<Sequence> {
    const res = await api.put(`/sequences/${id}`, data);
    return res.data;
  }

  async remove(id: string): Promise<void> {
    await api.delete(`/sequences/${id}`);
  }

  async pushToLemlist(id: string): Promise<PushResult> {
    const res = await api.post(`/sequences/${id}/push-to-lemlist`);
    return res.data;
  }

  async resyncToLemlist(id: string): Promise<ResyncResult> {
    const res = await api.post(`/sequences/${id}/resync-to-lemlist`);
    return res.data;
  }
}

const sequenceService = new SequenceService();
export default sequenceService;
